import { Field, Model } from 'serialize-ts';

@Model()
export class VolumePrice {

  @Field()
  totalCount: number;
}
